import React, { useEffect, useState } from "react";
import { BuilderAlertManager } from "./BuilderAlertManager";
import PopUp from "@components/molecules/PopUp";
import { messageType } from "@components/molecules/PopUp/types";
import { ButtonType, ButtonCategory } from "@components/atoms/Button/types";
import { useDispatch, useSelector } from "react-redux";
import {
  hideNavigationConfirmation,
  showNavigationConfirmation,
} from "@redux/slices/navigationHistorySlice";
import { NavigationHistoryState } from "@components/molecules/Breadcrumbs/utils";
import { useTranslation } from "react-i18next";
import { resetFiltersPayload } from "@redux/slices/searchFilters";
import { useNavigationHistory } from "../../../hooks/useNavigationHistory";
import { CommonActions } from "@react-navigation/native";
import { navigationRef } from "@navigations/utils/RootNavigation";
import Routes from "@navigations/Routes";
import { useTheme } from "styled-components/native";
import { DeviceEventEmitter } from "react-native";

const BuilderAlertModal = () => {
  const [visible, setVisible] = useState(false);
  const [text, setText] = useState("");
  const dispatch = useDispatch();
  const theme = useTheme();
  const { t } = useTranslation();
  const { clearRouteHistory } = useNavigationHistory();
  const { currentIndex, showConfirmationDialog, history } = useSelector(
    (state: any) => state.navigationHistory as NavigationHistoryState
  );

  useEffect(() => {
    BuilderAlertManager.registerModal(
      () => {
        dispatch(showNavigationConfirmation(currentIndex));
        setVisible(true);
      },
      () => {
        dispatch(hideNavigationConfirmation());
        setVisible(false);
      },
      (mText) => setText(mText)
    );
  }, [currentIndex]);

  if (!visible || !showConfirmationDialog) return null;

  return (
    <PopUp
      type={messageType.Generic}
      buttons={[
        {
          type: ButtonType.primary,
          title: t("reviewPage.stone.details.popUp.buttons.yes.text"),
          onPressAction: () => {
            const screen = history[0]?.screen;
            const params = history[0]?.params;

            if (history.length > 0) {
              const innerRoute =
                theme.isLargeScreen || theme.isTablet
                  ? {
                      name: screen,
                      params:
                        screen === "split-filter-screen"
                          ? { ...params, filterSplitStep: 2 }
                          : params,
                    }
                  : { name: Routes.Explore };
              if (navigationRef.isReady()) {
                navigationRef.dispatch(
                  CommonActions.reset({
                    index: 0,
                    routes: [
                      {
                        name: Routes.AppNavigator,
                        state: {
                          index: 0,
                          routes: [
                            {
                              name: Routes.ExploreNavigator,
                              state: {
                                index: 0,
                                routes: [innerRoute],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  })
                );
              }
            }
            DeviceEventEmitter.emit("CLEAR_JEWELRY_CONTEXT");
            clearRouteHistory();
            dispatch(resetFiltersPayload());
            setTimeout(() => BuilderAlertManager.confirm(), 0);
          },
          category: ButtonCategory.default,
        },
        {
          type: ButtonType.secondary,
          title: t("reviewPage.stone.details.popUp.buttons.cancel.text"),
          onPressAction: () => {
            BuilderAlertManager.cancel();
          },
        },
      ]}
      HtmlSource={{
        html: t(text || "reviewPage.stone.details.popUp.title.text"),
      }}
      styleKey="Body-R"
    />
  );
};

export default BuilderAlertModal;
